import { COMMUNICATION_NODE_SETTINGS } from "./communication";

export function CommunicationSettings(props) {
  const { communicationType, ...restProps } = props;

  return COMMUNICATION_NODE_SETTINGS[communicationType]({ ...restProps });
}
